import React from 'react'

import BaseInput from './BaseInput';

export default function EmailInput(props) {
    return (
        <BaseInput {...props}
                   type="email"/>
    )
}